export default __webpack_public_path__ + "static/media/5.1Vid.21ba93b1.mp4";